module.exports = __webpack_public_path__ + "static/media/girl-section-one.0a5a5fb7.png";